import React, { useContext, useState } from "react";
import { Form, Input, theme } from "antd";
import { noYesOptions } from "../../../../Options/commonOptions";
import {
  foleysCatheterTypeOptions,
  urinaryCatheterTypeOptions,
} from "../../../../Options/genExamOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../../helpers/utility";
import { DoctorInitialContext } from "../../../HistoryForm/DoctorHistoryFormProvider";

const UrinaryCatheter = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  const { token } = theme.useToken();
  const { formData } = useContext(DoctorInitialContext);
  const showCatheter = form.getFieldValue("urinary_catheter");
  const showType = form.getFieldValue("urinary_catheter_type");
  return (
    <>
      <DeselectableRadioGroup
        label={"Urinary Catheter"}
        name={"urinary_catheter"}
        options={noYesOptions}
        form={form}
        setRefresh={setRefresh}
      />

      {showCatheter === "yes" && (
        <div
          className="subsection-card"
          style={{
            borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
            background: "transparent",
            marginTop: "8px",
            padding: "8px 12px",
            borderRadius: "8px",
          }}
        >
          <DeselectableRadioGroup
            name={"urinary_catheter_type"}
            options={urinaryCatheterTypeOptions}
            form={form}
            setRefresh={setRefresh}
          />

          {showType === "foleys_catheter" && (
            <DeselectableRadioGroup
              label={"Type"}
              name={"foleys_catheter_type"}
              options={foleysCatheterTypeOptions}
              form={form}
            />
          )}

          <Form.Item label="No of Days on the Catheter" name="days_on_catheter">
            <Input
              className="nurse-assessment-days-field gen-exam-compact-input"
              addonBefore="No.of Days"
            />
          </Form.Item>
        </div>
      )}
    </>
  );
};

export default UrinaryCatheter;
